module.exports = __webpack_public_path__ + "static/media/tier-2.953411b8.jpg";